var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33366C2.5 5.19116 2.5 3.61949 3.47667 2.64366C4.4525 1.66699 6.02417 1.66699 9.16667 1.66699H10.8333C13.9758 1.66699 15.5475 1.66699 16.5233 2.64366C17.5 3.61949 17.5 5.19116 17.5 8.33366V11.667C17.5 14.8095 17.5 16.3812 16.5233 17.357C15.5475 18.3337 13.9758 18.3337 10.8333 18.3337H9.16667C6.02417 18.3337 4.4525 18.3337 3.47667 17.357C2.5 16.3812 2.5 14.8095 2.5 11.667V8.33366Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.33398H13.3332M6.6665 11.6673H10.8332",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5342_15426)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5842,
    y: 12,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#2B6ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.584 17C12.584 14.2385 14.8225 12 17.584 12C20.3455 12 22.584 14.2385 22.584 17C22.584 19.7615 20.3455 22 17.584 22C14.8225 22 12.584 19.7615 12.584 17ZM17.584 13C16.5231 13 15.5057 13.4214 14.7556 14.1716C14.0054 14.9217 13.584 15.9391 13.584 17C13.584 18.0609 14.0054 19.0783 14.7556 19.8284C15.5057 20.5786 16.5231 21 17.584 21C18.6449 21 19.6623 20.5786 20.4124 19.8284C21.1626 19.0783 21.584 18.0609 21.584 17C21.584 15.9391 21.1626 14.9217 20.4124 14.1716C19.6623 13.4214 18.6449 13 17.584 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0009 14.9167C18.0009 14.8062 17.957 14.7002 17.8789 14.622C17.8007 14.5439 17.6947 14.5 17.5842 14.5C17.4737 14.5 17.3677 14.5439 17.2896 14.622C17.2115 14.7002 17.1676 14.8062 17.1676 14.9167V16.5833H15.5009C15.3904 16.5833 15.2844 16.6272 15.2063 16.7054C15.1281 16.7835 15.0842 16.8895 15.0842 17C15.0842 17.1105 15.1281 17.2165 15.2063 17.2946C15.2844 17.3728 15.3904 17.4167 15.5009 17.4167H17.1676V19.0833C17.1676 19.1938 17.2115 19.2998 17.2896 19.378C17.3677 19.4561 17.4737 19.5 17.5842 19.5C17.6947 19.5 17.8007 19.4561 17.8789 19.378C17.957 19.2998 18.0009 19.1938 18.0009 19.0833V17.4167H19.6676C19.7781 17.4167 19.884 17.3728 19.9622 17.2946C20.0403 17.2165 20.0842 17.1105 20.0842 17C20.0842 16.8895 20.0403 16.7835 19.9622 16.7054C19.884 16.6272 19.7781 16.5833 19.6676 16.5833H18.0009V14.9167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5342_15426"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5842,
    y: 12,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackBookingIcon);
export default __webpack_public_path__ + "static/media/TrackBookingIcon.56e06f70bfd28877817c58531717f660.svg";
export { ForwardRef as ReactComponent };